/* MooseBorn — Judge.me reviews rendered by the theme.
   Both the card carousel ([data-mb-jc]) and the full list ([data-mb-jl]) read the same public endpoint Judge.me's own
   widget calls from the storefront (reviews_for_widget), so they work even when the widget metafield on the product is
   stale. Nothing is invented: every card is a review Judge.me holds for this product, shown word for word. */
(() => {
  'use strict';
  const d = document;
  const w = window;
  const cache = {};
  const lang = (d.documentElement.lang || 'en').slice(0, 5);
  const STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6L2.5 9.4l6.6-.8z"/></svg>';
  const CHECK = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const esc = (t) => String(t || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const once = (el, key) => { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; };

  const api = (shop, pid, page, per) => {
    const key = [shop, pid, page, per].join('|');
    if (!cache[key]) {
      const url = 'https://judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(shop) + '&shop_domain=' + encodeURIComponent(shop) + '&platform=shopify&page=' + page + '&per_page=' + per + '&product_id=' + pid;
      cache[key] = fetch(url, { credentials: 'omit' }).then((r) => { if (!r.ok) throw new Error('judge.me ' + r.status); return r.json(); }).catch((e) => { delete cache[key]; throw e; });
    }
    return cache[key];
  };

  const paras = (html) => {
    const box = d.createElement('div');
    box.innerHTML = html || '';
    const ps = Array.from(box.querySelectorAll('p')).map((p) => p.textContent.replace(/\s+/g, ' ').trim()).filter(Boolean);
    if (ps.length) return ps;
    const t = box.textContent.replace(/\s+/g, ' ').trim();
    return t ? [t] : [];
  };
  const picUrl = (p) => (typeof p === 'string' ? p : (p && (p.compact || p.small || p.original || p.huge)) || '');
  const norm = (r) => ({
    score: Math.max(1, Math.min(5, Math.round(Number(r.rating) || 5))),
    title: (r.title || '').trim(),
    paras: paras(r.body_html || r.body),
    author: (r.reviewer_name || (r.reviewer_initial ? r.reviewer_initial + '.' : '')).trim(),
    verified: !!r.verified_buyer,
    imported: (r.transparency_badges || []).indexOf('review_collected_from_another_provider') !== -1,
    date: r.created_at || '',
    pictures: (r.pictures_urls || []).map(picUrl).filter(Boolean),
    reply: r.reply_content ? paras(r.reply_content) : [],
  });
  const stars = (score, cls) => {
    let out = '';
    for (let i = 1; i <= 5; i++) out += STAR.replace('<svg ', i <= score ? '<svg ' : '<svg class="is-off" ');
    return '<span class="' + cls + '" role="img" aria-label="' + score + ' / 5">' + out + '</span>';
  };
  const fmtDate = (iso) => { try { return new Date(iso).toLocaleDateString(lang, { year: 'numeric', month: 'short', day: 'numeric' }); } catch (x) { return ''; } };
  const badges = (rv, i18n) => (rv.verified ? '<span class="mb-jc__verified">' + CHECK + esc(i18n.verified) + '</span>' : '') +
    (rv.imported && i18n.imported ? '<span class="mb-jc__tag">' + esc(i18n.imported) + '</span>' : '');
  const quote = (ps) => ps.map((p, i, a) => '<p>' + (i === 0 ? '“' : '') + esc(p) + (i === a.length - 1 ? '”' : '') + '</p>').join('');

  const card = (rv, i18n) => '<article class="mb-jc__card">' +
    (rv.title ? '<h3 class="mb-jc__title">' + esc(rv.title) + '</h3>' : '') +
    '<div class="mb-jc__body">' + quote(rv.paras) + '</div>' +
    '<div class="mb-jc__foot">' + stars(rv.score, 'mb-jc__stars') +
    '<span class="mb-jc__who">' + (rv.author ? '<span class="mb-jc__name">' + esc(rv.author) + '</span>' : '') + badges(rv, i18n) + '</span></div></article>';

  const row = (rv, i18n) => '<article class="mb-jl__item">' +
    '<div class="mb-jl__top">' + stars(rv.score, 'mb-jc__stars') + (rv.date ? '<time class="mb-jl__date" datetime="' + esc(rv.date) + '">' + esc(fmtDate(rv.date)) + '</time>' : '') + '</div>' +
    (rv.title ? '<h3 class="mb-jl__title">' + esc(rv.title) + '</h3>' : '') +
    '<div class="mb-jl__body">' + rv.paras.map((p) => '<p>' + esc(p) + '</p>').join('') + '</div>' +
    (rv.pictures.length ? '<div class="mb-jl__pics">' + rv.pictures.map((u) => '<img src="' + esc(u) + '" alt="" loading="lazy">').join('') + '</div>' : '') +
    '<div class="mb-jl__who">' + (rv.author ? '<span class="mb-jc__name">' + esc(rv.author) + '</span>' : '') + badges(rv, i18n) + '</div>' +
    (rv.reply.length ? '<div class="mb-jl__reply"><b>' + esc(i18n.reply || 'MooseBorn') + '</b>' + rv.reply.map((p) => '<p>' + esc(p) + '</p>').join('') + '</div>' : '') +
    '</article>';

  const i18nOf = (el) => ({
    verified: el.dataset.i18nVerified || 'Verified Buyer',
    imported: el.dataset.i18nImported || '',
    loadMore: el.dataset.i18nLoadMore || 'Load more reviews',
    reply: el.dataset.i18nReply || '',
    error: el.dataset.i18nError || 'Reviews could not be loaded. Please refresh.',
    count: el.dataset.i18nCount || '[n] reviews',
  });

  /* ---------- Card carousel ---------- */
  function initCarousel(sec) {
    if (!once(sec, 'mbJcInit')) return;
    const rail = sec.querySelector('[data-mb-jc-rail]');
    const i18n = i18nOf(sec);
    const max = parseInt(sec.dataset.max, 10) || 10;
    const design = !!(w.Shopify && w.Shopify.designMode);
    const show = (list) => {
      if (!list.length) return false;
      rail.innerHTML = list.slice(0, max).map((rv) => card(rv, i18n)).join('');
      delete rail.dataset.mbDots;
      const old = rail.nextElementSibling; if (old && old.classList.contains('mb-dots')) old.remove();
      if (w.mbInitRails) w.mbInitRails(sec);
      sec.hidden = false;
      return true;
    };
    const fromTemplate = () => {
      const tpl = sec.querySelector('template[data-mb-jc-src]');
      if (!tpl) return [];
      return Array.from(tpl.content.querySelectorAll('.jdgm-rev')).map((r) => norm({
        rating: (r.querySelector('[data-score]') || {}).getAttribute ? r.querySelector('[data-score]').getAttribute('data-score') : 5,
        title: (r.querySelector('.jdgm-rev__title') || {}).textContent,
        body_html: (r.querySelector('.jdgm-rev__body') || {}).innerHTML,
        reviewer_name: (r.querySelector('.jdgm-rev__author') || {}).textContent,
        verified_buyer: r.getAttribute('data-verified-buyer') === 'true',
      }));
    };
    api(sec.dataset.shop, sec.dataset.product, 1, Math.min(20, max))
      .then((j) => show((j.reviews || []).map(norm)))
      .catch(() => false)
      .then((ok) => { if (!ok && !show(fromTemplate()) && !design) sec.hidden = true; });
  }

  /* ---------- Full list with summary, histogram and paging ---------- */
  function initList(sec) {
    if (!once(sec, 'mbJlInit')) return;
    const i18n = i18nOf(sec);
    const per = parseInt(sec.dataset.per, 10) || 10;
    const limit = parseInt(sec.dataset.limit, 10) || 0;   // preview mode: show only the first N of page 1
    const summary = sec.querySelector('[data-mb-jl-summary]');
    const list = sec.querySelector('[data-mb-jl-list]');
    const more = sec.querySelector('[data-mb-jl-more]') || d.createElement('button');
    const status = sec.querySelector('[data-mb-jl-status]');
    const fallback = sec.querySelector('[data-mb-jl-fallback]');
    let page = 1; let pages = 1;
    const load = () => {
      more.disabled = true; more.classList.add('is-loading');
      return api(sec.dataset.shop, sec.dataset.product, page, per).then((j) => {
        let revs = (j.reviews || []).map(norm);
        if (limit) { revs = revs.slice(0, limit); }
        if (page === 1) {
          const n = Number(j.number_of_reviews) || revs.length;
          const avg = Number(j.average_rating) || 0;
          const hist = Array.isArray(j.histogram) ? j.histogram : [];
          if (summary) {
            summary.innerHTML = '<div class="mb-jl__avg"><span class="mb-jl__big">' + avg.toFixed(1) + '</span>' + stars(Math.round(avg), 'mb-jc__stars mb-jl__stars') +
              '<span class="mb-jl__n">' + esc(i18n.count.replace('[n]', n.toLocaleString(lang))) + '</span></div>' +
              (hist.length ? '<div class="mb-jl__hist">' + hist.slice().sort((a, b) => b.rating - a.rating).map((h) => '<div class="mb-jl__bar"><span>' + h.rating + STAR + '</span><i><b style="width:' + Math.max(0, Math.min(100, Number(h.percentage) || 0)) + '%"></b></i><small>' + (Number(h.frequency) || 0).toLocaleString(lang) + '</small></div>').join('') + '</div>' : '');
          }
          pages = (j.pagination && j.pagination.total_pages) || 1;
          list.innerHTML = '';
          if (!revs.length) throw new Error('empty');
        }
        list.insertAdjacentHTML('beforeend', revs.map((rv) => row(rv, i18n)).join(''));
        page++;
        more.hidden = limit > 0 || page > pages;
        more.disabled = false; more.classList.remove('is-loading');
        sec.hidden = false;
      }).catch(() => {
        more.disabled = false; more.classList.remove('is-loading');
        if (page === 1) {
          // Let Judge.me's own widget take over if it has rendered anything; otherwise say so.
          if (fallback && fallback.querySelector('.jdgm-rev')) { fallback.hidden = false; list.hidden = true; more.hidden = true; if (summary) summary.hidden = true; }
          else if (status) { status.textContent = i18n.error; status.hidden = false; }
        }
      });
    };
    more.addEventListener('click', load);
    load();
  }

  function initAll(root) {
    Array.prototype.forEach.call((root || d).querySelectorAll('[data-mb-jc]'), initCarousel);
    Array.prototype.forEach.call((root || d).querySelectorAll('[data-mb-jl]'), initList);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', () => initAll()); else initAll();
  d.addEventListener('shopify:section:load', (e) => initAll(e.target));
  w.mbJdgm = { api, norm, initAll };
})();
